import {
	Box,
	Paper,
	Typography,
	useTheme,
	CircularProgress,
	Grid,
} from "@mui/material";
import dayjs from "dayjs";
import api from "../../services/api";
import { useEffect, useRef, useState } from "react";
import useStyles from "./styles";
import MetricaApiComponent from "../../components/metricasApi/metricaApiComponent";
import GraphMetricasApi from "../../components/metricasApi/graphMetricasApi";
// import MetricaApiComponent from "../../../components/metricaApiComponent";

//Funcao para buscar os ultimos 90 dias e realizar analise com os dados da api
//Essa funcao serve para que seja renderizado todos os 90 dias, pois caso a API nao tenha
// dados referente ao 90 dias, o mesmo vai renderizar os dados da cor cinza
const dateGenerate = () => {
	const ultimos90Dias = [];
	for (let i = 0; i < 90; i++) {
		const data = new Date();
		data.setDate(data.getDate() - i);
		const objeto = {
			data: dayjs(
				data
					.toLocaleString("en-US", {
						timeZoneName: "longOffset",
						timeZone: "America/Sao_paulo",
					})
					.split(",")[0],
			).format("YYYY-MM-DD"), // Formato YYYY-MM-DD
		};

		ultimos90Dias.unshift(objeto);
	}
	return ultimos90Dias;
};

export default function Status(params) {
	const { setDay, day } = params;
	const theme = useTheme();
	const styles = useStyles(theme);
	const [nameApis, setNameApis] = useState([]);
	const [dataApis, setDataApis] = useState({});
	const [tempo, setTempo] = useState("");
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);
	/*   const [day, setDay] = useState(30); */
	const [dataGrafico, setDataGrafico] = useState([]);
	const [dias, setDias] = useState(dateGenerate);
	const [loading, setLoading] = useState(true);
	const [timeRequestdata, setTimeRequestdata] = useState([]);
	const [dataApisFilter, setDataApisFilter] = useState([]);
	const [apiConfigs, setApiConfigs] = useState([]);
	const ref = useRef(null);

	//Configuração de cor da api
	//key = propriedade de valor do objeto do backend
	//ex: zabbix = nome para verificar o nome da api que será renderizado

	/*  const apiConfigs = [
    {
      key: "zabbixTimeRequest",
      label: "zabbix",
      color: theme.palette.chip.colorText.high,
      zabbix: theme.palette.chip.colorText.high,
    },
    {
      key: "hubsoftTimeRequest",
      label: "hubsoft",
      color: theme.palette.secondary.main,
      hubsoft: theme.palette.secondary.main,
    },
  ]; */
	const apiColors = apiConfigs.reduce((acc, item) => {
		// pega as entradas (pares chave/valor)
		const entries = Object.entries(item);
		// última entrada
		const [lastKey, lastValue] = entries[entries.length - 1];
		// adiciona no acumulador
		acc[lastKey] = lastValue;
		return acc;
	}, {});

	//Ao iniciar o componente, chamar a funcao getDataApi() para receber os dados da API
	useEffect(() => {
		setLoading(true);
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};
		window.addEventListener("resize", handleResize);
		getDataApi(); //Chamada da funcao para buscar dados das APIs no backend
	}, []);

	//Ao receber os dados da API, fazer um filtro de apenas os dados que exista
	useEffect(() => {
		//Eetado para identificar o nome das APIs que foram identificadas no backend
		setNameApis(Object.keys(dataApis));
	}, [dataApis]);

	//Hook para realizar a renderização dos dados em diferentes telas diferentes
	//Aqui se encontra as funcionalidades de alterar a quantidade de dias que esta
	// sendo monitorado de acordo com o tamanho da tela

	useEffect(() => {
		//setar tempo multiplos de 30 de acordo com o tamanho da tela

		const a = -520.3654371226432;
		const b = 86.34673864454844;
		let func = ((x) => ((a + b * Math.log(x)) / 10).toFixed(0)) || 0;

		setTempo(
			parseInt(
				10 * func(windowWidth) <= 30
					? 30
					: 10 * func(windowWidth) >= 90
						? 90
						: 10 * func(windowWidth),
			),
		);
	}, [windowWidth]);
	useEffect(() => {
		const hoje = new Date();
		const trintaDias = new Date(hoje);
		trintaDias.setDate(hoje.getDate() - 30);

		//Hook para receber os dados para os grafico de tempo de resposta
		setDataGrafico(
			timeRequestdata?.filter(
				(data) =>
					new Date(data?.date) <= hoje && new Date(data?.date) >= trintaDias,
			),
		);
		setDay(30);
	}, [timeRequestdata]);

	useEffect(() => {
		handleChange();
	}, [day]);

	//Funcao para buscar dados da API
	const getDataApi = async () => {
		try {
			const response = await api.get("/metricas");
			setDataApis(response?.data?.dataAPis);
			setDataApisFilter(response?.data?.trafegoFilter);
			setTimeRequestdata(response?.data?.timeRequestData);
			const configColorsApi = response?.data?.apiConfigs;

			const colorKeys = Object.keys(theme.palette.colors)?.filter(
				(color) => color !== "white" && color !== "black",
			);

			if (configColorsApi) {
				const configColors = configColorsApi?.map((apiConf, index) => {
					// escolhe a cor em ordem, repetindo do começo se passar do limite
					const colorName = colorKeys[index % colorKeys?.length];
					const colorValue = theme.palette.colors[colorName].medium;

					return {
						...apiConf,
						color: colorValue,
						[apiConf?.label?.toLowerCase()]: colorValue,
					};
				});
				setApiConfigs(configColors);
			}
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	//Realizar filtro de tempo para grafico de tempo de respostas das APIs
	const handleChange = (event) => {
		/*  setDay(event.target.value); */

		const hoje = new Date();
		const seteDias = new Date(hoje);
		const trintaDias = new Date(hoje);
		const vinteQuatroHoras = new Date(hoje.getTime() - 24 * 60 * 60 * 1000);
		seteDias.setDate(hoje.getDate() - 7);
		trintaDias.setDate(hoje.getDate() - 30);

		if (day === 30) {
			setDataGrafico(
				timeRequestdata?.filter(
					(data) =>
						new Date(data?.date) <= hoje && new Date(data?.date) >= trintaDias,
				),
			);
		} else if (day === 7) {
			setDataGrafico(
				timeRequestdata?.filter(
					(data) =>
						new Date(data?.date) <= hoje && new Date(data?.date) >= seteDias,
				),
			);
		} else if (day === 1) {
			setDataGrafico(
				timeRequestdata?.filter(
					(data) =>
						new Date(data?.date) <= hoje &&
						new Date(data?.date) >= vinteQuatroHoras,
				),
			);
		}
	};
	//Funcao para analisar a atividade de um dia em especifico
	//Funcao necessaria para realizar a analise da atividade da API de todos os dias
	const analiseAtividadeApiDay = (dataApi, requisicoes) => {
		if (requisicoes) {
			return parseFloat((dataApi * 100) / requisicoes).toFixed(2);
		} else {
			return 0;
		}
	};

	//Funcao para analisar a atividade de todos os dias
	const analiseAtividadeApi = (data, indiceAPi) => {
		let requisicoesTotal = [];
		let requestFilter = [];

		//Verificar requisições que tiveram exito
		const requestSuccess =
			Array.isArray(data) &&
			data.map(
				(apis) =>
					apis[indiceAPi]?.filter(
						(api) => api?.httpCode === 200 || api?.httpCode === 201,
					)?.length,
			);

		//Verificar quantas requisições teve em cada dia dos ultimos 90 dias
		const requestDay =
			Array.isArray(data) &&
			data.map((apis) => apis[indiceAPi]?.filter((data) => data)?.length);

		//Verificar em quais dias ocorreu alguam requisição.
		//Caso no dia verificado seja identificado pelo menos uma requisição (sucesso ou nao)
		//Adicionar quantas requisições ocorreu no dia (requisicoesTotal) e quantas tiveram sucesso (requestFilter)
		Array.isArray(requestDay) &&
			requestDay?.forEach((requisicoesDay, index) => {
				if (requisicoesDay !== 0) {
					requisicoesTotal.push(requisicoesDay);
					requestFilter.push(requestSuccess[index]);
				}
			});

		//O for vai realizar a analise de cada dia que ocorreu pelo menos uma requisição e adicionar analiseDiario
		let analiseDiario = 0;
		for (let i = 0; i < requisicoesTotal?.length; i++) {
			analiseDiario += parseFloat(
				analiseAtividadeApiDay(requestFilter[i], requisicoesTotal[i]),
			);
		}
		//Retornar a analise de todos os dias que tiveram pelo menos uma requisição
		const analiseCompleto = (analiseDiario / requisicoesTotal?.length).toFixed(
			2,
		);
		//Caso a API seja recente e nao tem dados de nenhum dia, o mesmo vai retornar como 0.00% sobre a atividade da API
		return isNaN(analiseCompleto) ? 0.0 : analiseCompleto;
	};

	//funcao para chamar api com os dados a cada 5 minutos
	//setInterval(getDataApi, 60 * 1000);

	return (
		<Box sx={styles.containerComponent}>
			{loading ? (
				<Box sx={styles.containerLoading}>
					<CircularProgress />
				</Box>
			) : (
				<>
					<Box sx={styles.containerPaper} ref={ref}>
						<Grid
							container
							columns={{ xs: 2, sm: 4, md: 6, lg: 6, xl: 6, xxl: 6 }}
							flexGrow={1}
							spacing={1}
						>
							{nameApis.map((apiName, index) => (
								<Grid item xs={2} sm={4} md={6} lg={6} xl={6} xxl={3}>
									<Paper
										sx={{
											...styles.paper,
											backgroundColor: theme.palette.background.paper,
										}}
										elevation={theme.palette.mode == "dark" ? 0 : 3}
									>
										<MetricaApiComponent
											apiName={apiName}
											tempo={tempo}
											index={index}
											dataApisFilter={dataApisFilter?.slice(-tempo)}
											dias={dias}
											analiseAtividadeApiDay={analiseAtividadeApiDay}
											analiseAtividadeApi={analiseAtividadeApi}
											windowWidth={windowWidth}
											apiColors={apiColors}
											apiConfigs={apiConfigs}
										/>
									</Paper>
								</Grid>
							))}

							<Grid item xs={2} sm={4} md={6} lg={6} xl={6} xxl={6}>
								<Paper
									sx={{
										...styles.paperGraph,
										maxWidth: windowWidth < 1830 ? "1000px" : "100%",
									}}
									elevation={theme.palette.mode == "dark" ? 0 : 3}
								>
									<GraphMetricasApi
										dataGrafico={dataGrafico}
										windowWidth={windowWidth}
										/*       handleChange={handleChange} */
										day={day}
										apiConfigs={apiConfigs}
									/>
								</Paper>
							</Grid>
						</Grid>
					</Box>
				</>
			)}
		</Box>
	);
}
